'use client';

import { Body } from '../typography/Body';
import clsxm from '../utils/style';
import { Button } from './Button';
import { FlexContainer } from './FlexContainer';
import { Switch } from './Switch';

export interface FlagOverrideRowProps {
  name: string;
  nameSuffix?: React.ReactNode;
  description?: React.ReactNode;
  truncateDescription?: boolean;
  checked?: boolean;
  fallbackControl?: React.ReactNode;
  onCheckedChange?: (next: boolean) => void;
  disabled?: boolean;
  showReset: boolean;
  onReset: () => void;
  resetAriaLabel?: string;
}

export function FlagOverrideRow({
  name,
  nameSuffix,
  description,
  truncateDescription,
  checked,
  fallbackControl,
  onCheckedChange,
  disabled,
  showReset,
  onReset,
  resetAriaLabel = `Reset ${name} to server value`,
}: FlagOverrideRowProps) {
  return (
    <FlexContainer
      className="gap-3 border border-border-secondary rounded-md px-3 py-2 w-full"
      items="center"
      justify="between"
    >
      <FlexContainer className="min-w-0" direction="column">
        <FlexContainer className="gap-2 min-w-0" items="center">
          <Body className="truncate" size="sm">
            {name}
          </Body>
          {nameSuffix}
        </FlexContainer>
        {description !== undefined && (
          <Body className={clsxm('text-content-secondary', truncateDescription && 'truncate')} size="sm">
            {description}
          </Body>
        )}
      </FlexContainer>
      <FlexContainer className="gap-2 shrink-0" items="center">
        {checked !== undefined ? (
          <Switch
            aria-label={`Toggle ${name}`}
            checked={checked}
            disabled={disabled}
            onCheckedChange={onCheckedChange}
          />
        ) : (
          fallbackControl
        )}
        {showReset && (
          <Button aria-label={resetAriaLabel} disabled={disabled} onClick={onReset} size="sm" variant="quaternary">
            Reset
          </Button>
        )}
      </FlexContainer>
    </FlexContainer>
  );
}
